import apiClient from './apiClient';
import { GET_TRANSPORTATION_LIST_URL } from './apiUrl';

const getTransportationListApi = () => {
  return apiClient.get(GET_TRANSPORTATION_LIST_URL);
};

export default getTransportationListApi;
